export const getValue = (data: any[], filterField: string, filterValue: any) => {
	return data.filter((x: any) => x[filterField] === filterValue || filterValue === undefined).length > 0
		? +data.filter((x: any) => x[filterField] === filterValue || filterValue === undefined)[0].count : 0;
};